import store from "@/store";
import DcbService from "@/services/dcbService";
import getUserSessionData from "@/functions/getUserSessionData";
import {Brands} from "../brand/brandConfig";
import {ServiceIds} from "../config";
import {injectScript} from "@/functions/injectTellium";
import getServiceId from "@/functions/getServiceId";
import PredictorService from "@/services/predictorService";
import MtnZAService from "@/services/mtnZAService";
import WorldPlayService from "@/services/worldPlayService";
import cleanMtnUser from "@/functions/cleanMtnUser";
import Cloud7Service from "@/services/cloud7Service";
import cleanGrameenphoneUser from "@/functions/cleanGrameenphoneUser";
import isUserSubscribed from "@/functions/isUserSubscribed";
import getCurrentProductId, {getProductIdForService} from "@/functions/getCurrentProductId";

const MTN_CRICKET_ZONE_MIRROR_URL = 'https://mtn-za-welcome-cricketzone-co-za.migration.penrosesystems.com';

export async function userAuthenticate(to, from, next) {
    if (store.state.brandConfig.brand.includes('vc')) {
        try {
            await injectScript();
            console.log('Injected Telium and script loaded successfully');
        } catch (error) {
            console.error('Failed to load the script:', error);
        }
    }
    const {brand} = store.state.brandConfig;
    if (brand === Brands.VodacomEvinaSouthAfricaEnglish) await userAuthenticateEncryptedFlow(to, from, next)
    else if (brand === Brands.MTNWorldPlaySouthAfticaEnglish) await userAuthenticateWorldPlay(to, from, next)
    else if (brand === Brands.TelkomWorldPlaySouthAfticaEnglish) await userAuthenticateWorldPlay(to, from, next)
    else if (brand === Brands.WorldPlaySouthAfticaEnglish) await userAuthenticateWorldPlay(to, from, next)
    else if (brand === Brands.GrameenphoneBangladeshEnglish) await userAuthenticateGrameenphone(to, from, next)
    else await userAuthenticateNormalFlow(to, from, next);
}


async function userAuthenticateWorldPlay(to, from, next) {
    if (store.state.user) {
        store.commit('setIsLoading', false);
        return next();
    }

    const allowedRoutes = ['TermsAndConditions'];
    if (allowedRoutes.includes(to.name)) return next();

    const urlParams = new URLSearchParams(window.location.search);
    const wpMsisdn = urlParams.get('tn');
    const urlMsisdn = urlParams.get('msisdn') ?? localStorage.getItem(`msisdn`);
    const msisdn = wpMsisdn ? wpMsisdn : urlMsisdn
    if (!msisdn) {
        window.open(MTN_CRICKET_ZONE_MIRROR_URL, '_self');
        return next()
    }
    localStorage.setItem(`msisdn`, msisdn)
    const getUser = await WorldPlayService.getUser(msisdn, getCurrentProductId());
    const userData = {
        ...getUser,
        msisdn: getUser.Msisdn,
    };
    const cleanedUser = cleanMtnUser(userData)
    // Bypass DOI for test MSISDN when accessed via URL parameter
    const testMsisdn = '27712866546';
    if (`${msisdn}` === `27603807829` || (`${msisdn}` === testMsisdn && urlParams.get('msisdn') === testMsisdn)) {
        getUser.Status = 'active'
    }
    const validUser = getUser.Status.toLowerCase() === 'pending' || getUser.Status.toLowerCase() === 'active';
    if (validUser) {
        await setUserDataMtn(cleanedUser, next, to);
    } else {
        return window.open(MTN_CRICKET_ZONE_MIRROR_URL, '_self');
    }
}

async function userAuthenticateGrameenphone(to, from, next) {
    if (store.state.user) {
        store.commit('setIsLoading', false);
        return next();
    }

    const allowedRoutes = ['TermsAndConditions', 'RequestOtp'];
    if (allowedRoutes.includes(to.name)) return next();

    const urlParams = new URLSearchParams(window.location.search);
    const urlMsisdn = urlParams.get('msisdn') ?? localStorage.getItem('msisdn');

    if (!urlMsisdn) {
        store.commit('setIsLoading', false);
        return next({name: 'RequestOtp'});
    }

    try {
        store.commit('setIsLoading', true);
        localStorage.setItem('msisdn', urlMsisdn);

        const getUserResponse = await Cloud7Service.getUser(urlMsisdn, getCurrentProductId());
        const cleanedUser = cleanGrameenphoneUser(getUserResponse.data);

        if (cleanedUser && cleanedUser.status?.toLowerCase() === 'active') {
            store.commit('setUser', {
                msisdn: urlMsisdn,
                status: cleanedUser.status,
                ...cleanedUser
            });
            store.commit('setMsisdn', urlMsisdn);
            store.commit('setIsLoading', false);
            return next();
        } else {
            store.commit('setIsLoading', false);
            return next({name: 'RequestOtp'});
        }
    } catch (error) {
        console.error('Error authenticating Grameenphone user:', error);
        store.commit('setIsLoading', false);
        return next({name: 'RequestOtp'});
    }
}

async function userAuthenticateEncryptedFlow(to, from, next) {
    if (store.state.user || to.name === 'Wifi' || to.name === 'DoiTwo' || to.name === 'TimeoutError') {
        store.commit('setIsLoading', false);
        return next();
    }
    const urlParams = new URLSearchParams(window.location.search);
    const token = urlParams.get('token') ?? localStorage.getItem('token');
    const encryptedMsisdn = urlParams.get('encryptedMsisdn') ?? localStorage.getItem('encryptedMsisdn');
    const campaignId = urlParams.get('campaignId') || urlParams.get('cid');
    const googleClickId = urlParams.get('gclid');
    const clickId = urlParams.get('clickId');

    if (campaignId) setCampaignId(campaignId)
    if (googleClickId) setGoogleClickId(googleClickId)
    if (clickId) setClickId(clickId)
    if (encryptedMsisdn && token) {
        return await storeUserDetails(encryptedMsisdn, token, next);
    } else {
        store.commit('setIsLoading', false);
        return next({name: 'Wifi'});
    }
}

async function userAuthenticateNormalFlow(to, from, next) {
    const urlParams = new URLSearchParams(window.location.search);
    const encryptedMsisdn = urlParams.get('e-msisdn');
    if (store.state.user) {
        if (redirectFreeUserFromPredictorAndFantasy(to, next)) return;
        return next();
    }
    const userSessionData = getUserSessionData();
    console.log(store.state.brandConfig)
    const userMsisdn = userSessionData.msisdn ? userSessionData.msisdn : store.state.brandConfig.demoMsisdn
    if (userMsisdn) {
        await setUserData(userMsisdn, userSessionData.serviceId, next, to);
    }

    const allowedRoutes = ['TermsAndConditions', 'HomeView', 'NewsHome', 'MenuView', 'UpcomingFixtures', 'RequestOtp', 'NewsVideos', 'NewsArticles', 'NewsVideo', 'NewsArticle', 'NewsExclusive'];
    if (allowedRoutes.includes(to.name) && !encryptedMsisdn) return next();
    if (!allowedRoutes.includes(to.name) && !store.state.user) return next({name: 'RequestOtp'});

    const campaignId = urlParams.get('campaignId') || urlParams.get('cid');
    const googleClickId = urlParams.get('gclid');
    const clickId = urlParams.get('clickId');
    const msisdn = urlParams.get('msisdn') ?? localStorage.getItem('msisdn');
    const isMiniApp = urlParams.get('miniApp');

    if (msisdn && isMiniApp) return await miniAppLogin(msisdn, next);
    if (campaignId) setCampaignId(campaignId)
    if (googleClickId) setGoogleClickId(googleClickId)
    if (clickId) setClickId(clickId)
    if (encryptedMsisdn) return await encryptedMsisdnAuth(encryptedMsisdn, next, campaignId);

    store.commit('setIsLoading', false);
    return next();
}

async function miniAppLogin(msisdn, next) {
    localStorage.setItem('isMiniApp', true);
    await getMultiTierService(msisdn);
    return await redirectBasedOnUserStatus(next);
}

function setCampaignId(campaignId) {
    store.commit('setCampaignId', campaignId);
}

function setGoogleClickId(googleClickId) {
    store.commit('setGoogleClickId', googleClickId);
}

function setClickId(clickId) {
    store.commit('setClickId', clickId);
}

async function storeUserDetails(encryptedMsisdn, token, next) {
    const user = (await getUser(encryptedMsisdn, token)).data;
    await setEncryptedUserData(user, token, encryptedMsisdn);
    return await redirectBasedOnUserStatusMarketingFlow(user, next);
}

async function redirectBasedOnUserStatusMarketingFlow(user, next) {
    //TODO look at this logic !!
    store.commit('setIsLoading', false);
    const urlParams = new URLSearchParams(window.location.search);
    const action = urlParams.get('action');

    if (user.status === "Active" && user.serviceId !== ServiceIds.free) return next({name: 'LandingPage'});
    else if (user.status === 'Content Blocked') return next({path: `/error/:${user.status}`})
    // else if (action) return await handleActionClick(user, action, next);
    else return next({name: 'DoiTwo'});
    // Need to implement this page else if(user?.contentBlockedEnabled) return next({name: 'ContentBlockOptIn'});
}

async function getUser(encryptedMsisdn, token) {
    const serviceId = await getMultiTierServiceV2(token);
    return await DcbService.getUserViaEncryptedMsisdn(encryptedMsisdn, token, serviceId);
}

async function setEncryptedUserData(userDataResponse, token = undefined, encryptedMsisdn = undefined) {
    await DcbService.trackLoginV2(token);
    store.commit('setUser', userDataResponse.data);
    store.commit('setToken', token);
    store.commit('setEncryptedMsisdn', encryptedMsisdn);
    localStorage.setItem('token', token);
    localStorage.setItem('encryptedMsisdn', encryptedMsisdn);
}

async function encryptedMsisdnAuth(encryptedMsisdn, next, campaignId) {
    const {rawMsisdn} = (await DcbService.decryptMsisdn(encryptedMsisdn)).data;
    sessionStorage.setItem(`msisdn`, rawMsisdn)
    const msisdn = sessionStorage.getItem('msisdn')
    await getMultiTierService(msisdn);
    return await redirectBasedOnUserStatus(next, campaignId);
}

async function getMultiTierService(msisdn) {
    const {serviceId} = (await DcbService.getUserViaProductId(msisdn, getCurrentProductId())).data;
    store.commit('setServiceId', serviceId);
    store.commit('setMsisdn', msisdn);
}

async function getMultiTierServiceV2(token) {
    const getMultiTierServiceResponse = await DcbService.getMultiTierServiceV2(token);
    const getServiceIdByDescriptionResponse = getServiceIdByDescription(getMultiTierServiceResponse.data);
    setServiceIdValues(getServiceIdByDescriptionResponse);
    return getServiceIdByDescriptionResponse
}

function setServiceIdValues(serviceId) {
    localStorage.setItem('serviceId', serviceId);
    store.commit('setServiceId', serviceId);
}

async function redirectBasedOnUserStatus(next, campaignId) {
    const user = (await DcbService.getUserViaProductId(store.state.msisdn, getCurrentProductId())).data;
    store.commit('setUser', user);
    if (!user) return next({name: 'WelcomeView'});
    if (campaignId) {
        if (`${campaignId}` === `125` && getServiceId(store.state.user.serviceId) < 2) {
            next({name: 'ConfirmSubscription', params: {price: `5`, interval: 'day'}, replace: true});
        } else return next({name: 'HomeView'});
    } else return next({name: 'HomeView'});
}

function getServiceIdByDescription(array) {
    return array[0].Description;
}

function redirectFreeUserFromPredictorAndFantasy(to, next) {
    if (!store.state.user && (to.path.includes('predictor') || to.path.includes('fantasy'))) { next({name: 'RequestOtp'}); return true; }
    const isRestrictedPath = to.path.includes('predictor') || to.path.includes('fantasy');
    if (!isRestrictedPath) return false;
    const isVodacom = store.state.brandConfig.brand.includes('vc');
    if (isVodacom) {
        if (!isUserSubscribed(store.state.user)) { next({name: 'MenuView'}); return true; }
    } else {
        if (getServiceId(store.state.user.serviceId) < 2) { next({name: 'MenuView'}); return true; }
    }
    return false;
}

async function setUserData(msisdn, serviceId, next, to) {
    let user
    store.commit('setMsisdn', msisdn);
    store.commit('setServiceId', serviceId);
    if (store.state.brandConfig.brand.includes('vc')) user = (await DcbService.getUserViaProductId(msisdn, getProductIdForService(serviceId))).data;
    if (store.state.brandConfig.brand.includes('mtn')) user = (await MtnZAService.getUserViaMsisdn(msisdn, getProductIdForService(serviceId))).data.user;
    store.commit('setUser', user);
    store.commit('setIsLoading', false);
    if (redirectFreeUserFromPredictorAndFantasy(to, next)) return;
    await setPredictorUserData(to, msisdn)
    return next();
}

async function setUserDataMtn(user, next, to) {
    store.commit('setMsisdn', user.msisdn);
    store.commit('setServiceId', user.serviceId);
    // TODO: if (store.state.brandConfig.brand.includes('telkom')) user = (await TelkomZAService.getUserViaMsisdn(msisdn, store.state.brandConfig.productId)).data.user;
    store.commit('setUser', user);
    store.commit('setIsLoading', false);
    await setPredictorUserData(to, user.msisdn)
    return next();
}

async function setPredictorUserData(to, msisdn) {
    const allowedPaths = ['/predictor/upcoming-rounds', '/predictor/my-rounds'];
    if (!allowedPaths.includes(to.path)) return;
    const response = await PredictorService.getUserStats(msisdn);
    store.commit('setPredictorUserStats', response);
}
